import { useLocation, useNavigate } from "react-router-dom";
import { BottomNavigation, BottomNavigationAction, Paper } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import { DASHBOARD_PATHS } from "../routes/paths";
import { ImSpoonKnife } from "react-icons/im";
import { MdHistory } from "react-icons/md";
import AuthService from "../services/authService";

export default function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const isAuthenticated = !!AuthService._getAccessToken();

  const navItems = [
    isAuthenticated && {
      label: "Recents",
      path: DASHBOARD_PATHS.OLD_ORDERS,
      icon: <MdHistory size={20} />,
    },
    {
      label: "Food",
      path: DASHBOARD_PATHS.MENU,
      icon: <ImSpoonKnife size={20} />,
    },
    {
      label: "Settings",
      path: DASHBOARD_PATHS.SETTINGS,
      icon: <SettingsIcon />,
    },
  ].filter(Boolean);

  return (
    <Paper
      sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}
      elevation={3}
    >
      <BottomNavigation
        value={location.pathname}
        onChange={(event, newValue) => navigate(newValue)}
        showLabels
      >
        {navItems.map((item) => (
          <BottomNavigationAction
            key={item.path}
            label={item.label}
            value={item.path}
            icon={item.icon}
          />
        ))}
      </BottomNavigation>
    </Paper>
  );
}
